import {
  ESimulatorAMS275912SteelClass,
} from '@/types/simulator.ts';

const details: Record<ESimulatorAMS275912SteelClass, string> = {
  [ESimulatorAMS275912SteelClass.GROUP_0]: 'HLSA, zwykły węgiel – 5,1 do 25 µm',
  [ESimulatorAMS275912SteelClass.GROUP_1]: '4140, 4340, Nitralloy 135 – stale niskostopowe 5,1 do 25, stale narzędziowe 2,5 do 15',
  [ESimulatorAMS275912SteelClass.GROUP_2]: 'Żeliwo – 5,1 do 25 µm',
};

export default {
  details,
};
